// extracted by mini-css-extract-plugin
export default {"bottomTable":"styles_bottomTable__BJIJQ","borderless":"styles_borderless__otCvr"};